/**
 * PilotHintTextContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled pilot hint text container.
 */
const PilotHintTextContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  left: ${Screen.widthRatio * 122}px;
  position: relative;
  text-align: center;
`;

export default PilotHintTextContainer;
